import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet';

import './admin-layout.css';

type AdminLayoutProps = {
  readonly children: ReactNode;
  readonly title: string;
};

function AdminLayout({ children, title }: AdminLayoutProps): JSX.Element {
  return (
    <>
      <Helmet title={title} />
      <div className='admin-layout-container'>
        <div className='admin-content-container'>{children}</div>
      </div>
    </>
  );
}

AdminLayout.displayName = 'AdminLayout';

export default AdminLayout;
